export default __webpack_public_path__ + "static/media/save_to_homescreen_android.20294b2b.png";